import { IS_BABYLON_NATIVE_JSCORE } from "./utils";

// Minimal global shims for Babylon Native (JSCore). The runtime's fetch
// polyfill returns response-shaped objects but does not export the web's
// Response/Request/Headers classes — so third-party code probing
// `x instanceof Response` throws ReferenceError (the bare identifier doesn't
// resolve). Dummy classes make those probes evaluate to false, which sends
// libraries (e.g. @loaders.gl) down their non-Response input paths.
export function installNativeShims(): void {
  if (!IS_BABYLON_NATIVE_JSCORE) {
    return;
  }
  const g = globalThis as any;
  if (typeof g.Response === "undefined") {
    g.Response = class Response { };
  }
  if (typeof g.Request === "undefined") {
    g.Request = class Request { };
  }
  if (typeof g.Headers === "undefined") {
    g.Headers = class Headers { };
  }
}
